import Group from "./Group/Group"
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, variableRender, setGroupLabel, actions, isEhFlow) {
    if (action.actionName === types.GROUP) {
        return <Group action={action} inputName="loop" variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} setGroupLabel={setGroupLabel} actions={actions} isEhFlow={isEhFlow} />;
    }
}

export default Actions;
